import { render, staticRenderFns } from "./InstrumentView.vue?vue&type=template&id=780c6b3b"
import script from "./InstrumentView.vue?vue&type=script&lang=ts"
export * from "./InstrumentView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports